import _toConsumableArray from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _objectSpread from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/buildAgent/buildAgent/work/89e96d43034d21ee/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
var ct = Object.create,
    Ie = Object.defineProperty;
var mt = Object.getOwnPropertyDescriptor;
var dt = Object.getOwnPropertyNames;
var pt = Object.getPrototypeOf,
    ft = Object.prototype.hasOwnProperty;

var ht = function ht(t) {
  return Ie(t, "__esModule", {
    value: !0
  });
};

var vt = function vt(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};

var Tt = function Tt(t, e, n) {
  if (e && typeof e == "object" || typeof e == "function") {
    var _iterator = _createForOfIteratorHelper(dt(e)),
        _step;

    try {
      var _loop = function _loop() {
        var r = _step.value;
        !ft.call(t, r) && r !== "default" && Ie(t, r, {
          get: function get() {
            return e[r];
          },
          enumerable: !(n = mt(e, r)) || n.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    It = function It(t) {
  return Tt(ht(Ie(t != null ? ct(pt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
    get: function get() {
      return t.default;
    },
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t);
};

var Ue = vt(function (ie, Fe) {
  (function (t, e) {
    typeof ie == "object" && typeof Fe != "undefined" ? e(ie) : typeof define == "function" && define.amd ? define(["exports"], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
  })(ie, function (t) {
    "use strict";

    var e = function e(p) {
      return function (h) {
        var o = p(h);
        return h.add(o), o;
      };
    },
        n = function n(p) {
      return function (h, o) {
        return p.set(h, o), o;
      };
    },
        r = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER,
        a = 536870912,
        u = a * 2,
        b = function b(p, h) {
      return function (o) {
        var x = h.get(o),
            M = x === void 0 ? o.size : x < u ? x + 1 : 0;
        if (!o.has(M)) return p(o, M);

        if (o.size < a) {
          for (; o.has(M);) {
            M = Math.floor(Math.random() * u);
          }

          return p(o, M);
        }

        if (o.size > r) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");

        for (; o.has(M);) {
          M = Math.floor(Math.random() * r);
        }

        return p(o, M);
      };
    },
        W = new WeakMap(),
        ee = n(W),
        m = b(ee, W),
        c = e(m);

    t.addUniqueNumber = c, t.generateUniqueNumber = m, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  });
});
import Et, { forwardRef as bt } from "react";

function gt(t) {
  return bt(function (n, r) {
    var a = _objectSpread({}, n);

    !a.onPrompt && t.prototype.onPrompt && (a.onPrompt = function () {
      t.prototype.onPrompt();
    }), !a.onIdle && t.prototype.onIdle && (a.onIdle = function () {
      t.prototype.onIdle();
    }), !a.onActive && t.prototype.onActive && (a.onActive = function (b) {
      t.prototype.onActive(b);
    }), !a.onAction && t.prototype.onAction && (a.onAction = function (b) {
      t.prototype.onAction(b);
    });
    var u = $(a);
    return typeof r == "function" ? r(u) : r && (r.current = u), Et.createElement(t, _objectSpread(_objectSpread({}, n), u));
  });
}

import { useEffect as U, useRef as f, useCallback as I } from "react";
var K = It(Ue());

var We = function We(t) {
  return t.method !== void 0 && t.method === "call";
};

var Be = function Be(t) {
  return t.error === null && typeof t.id == "number";
};

var Ve = function Ve(t) {
  var e = new Map([[0, function () {}]]),
      n = new Map([[0, function () {}]]),
      r = new Map(),
      a = new Worker(t);
  return a.addEventListener("message", function (_ref) {
    var m = _ref.data;

    if (We(m)) {
      var _m$params = m.params,
          c = _m$params.timerId,
          d = _m$params.timerType;

      if (d === "interval") {
        var p = e.get(c);

        if (typeof p == "number") {
          var h = r.get(p);
          if (h === void 0 || h.timerId !== c || h.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (typeof p != "undefined") p();else throw new Error("The timer is in an undefined state.");
      } else if (d === "timeout") {
        var _p = n.get(c);

        if (typeof _p == "number") {
          var _h = r.get(_p);

          if (_h === void 0 || _h.timerId !== c || _h.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (typeof _p != "undefined") _p(), n.delete(c);else throw new Error("The timer is in an undefined state.");
      }
    } else if (Be(m)) {
      var _c = m.id,
          _d = r.get(_c);

      if (_d === void 0) throw new Error("The timer is in an undefined state.");
      var _p2 = _d.timerId,
          _h2 = _d.timerType;
      r.delete(_c), _h2 === "interval" ? e.delete(_p2) : n.delete(_p2);
    } else {
      var _c2 = m.error.message;
      throw new Error(_c2);
    }
  }), {
    clearInterval: function clearInterval(m) {
      var c = (0, K.generateUniqueNumber)(r);
      r.set(c, {
        timerId: m,
        timerType: "interval"
      }), e.set(m, c), a.postMessage({
        id: c,
        method: "clear",
        params: {
          timerId: m,
          timerType: "interval"
        }
      });
    },
    clearTimeout: function clearTimeout(m) {
      var c = (0, K.generateUniqueNumber)(r);
      r.set(c, {
        timerId: m,
        timerType: "timeout"
      }), n.set(m, c), a.postMessage({
        id: c,
        method: "clear",
        params: {
          timerId: m,
          timerType: "timeout"
        }
      });
    },
    setInterval: function setInterval(m, c) {
      var d = (0, K.generateUniqueNumber)(e);
      return e.set(d, function () {
        m(), typeof e.get(d) == "function" && a.postMessage({
          id: null,
          method: "set",
          params: {
            delay: c,
            now: performance.now(),
            timerId: d,
            timerType: "interval"
          }
        });
      }), a.postMessage({
        id: null,
        method: "set",
        params: {
          delay: c,
          now: performance.now(),
          timerId: d,
          timerType: "interval"
        }
      }), d;
    },
    setTimeout: function setTimeout(m, c) {
      var d = (0, K.generateUniqueNumber)(n);
      return n.set(d, m), a.postMessage({
        id: null,
        method: "set",
        params: {
          delay: c,
          now: performance.now(),
          timerId: d,
          timerType: "timeout"
        }
      }), d;
    }
  };
};

var Q = null,
    He = function He(t, e) {
  return function () {
    if (Q !== null) return Q;
    var n = new Blob([e], {
      type: "application/javascript; charset=utf-8"
    }),
        r = URL.createObjectURL(n);
    return Q = t(r), Q.setTimeout(function () {
      return URL.revokeObjectURL(r);
    }, 0), Q;
  };
};

var Ge = "(()=>{\"use strict\";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:\"call\",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener(\"message\",(i=>{let{data:s}=i;try{if(\"clear\"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if(\"interval\"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id \"'.concat(t,'\".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if(\"timeout\"!==i)throw new Error('The given type \"'.concat(i,'\" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id \"'.concat(e,'\".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if(\"set\"!==s.method)throw new Error('The given method \"'.concat(s.method,'\" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if(\"interval\"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,\"interval\"))})(i,a,n);else{if(\"timeout\"!==d)throw new Error('The given type \"'.concat(d,'\" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,\"timeout\"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();";

var se = He(Ve, Ge),
    qe = function qe(t) {
  return se().clearInterval(t);
},
    je = function je(t) {
  return se().clearTimeout(t);
},
    Ye = function Ye(t, e) {
  return se().setInterval(t, e);
},
    Je = function Je(t, e) {
  return se().setTimeout(t, e);
};

var w = (typeof window == "undefined" ? "undefined" : typeof window) == "object";
var T = {
  setTimeout: w ? setTimeout.bind(window) : setTimeout,
  clearTimeout: w ? clearTimeout.bind(window) : clearTimeout,
  setInterval: w ? setInterval.bind(window) : setInterval,
  clearInterval: w ? clearInterval.bind(window) : clearInterval
},
    Z = {
  setTimeout: Je,
  clearTimeout: je,
  setInterval: Ye,
  clearInterval: qe
};

function wt() {
  T.setTimeout = setTimeout, T.clearTimeout = clearTimeout, T.setInterval = setInterval, T.clearInterval = clearInterval, Z.setTimeout = setTimeout, Z.clearTimeout = clearTimeout, Z.setInterval = setInterval, Z.clearInterval = clearInterval;
}

function ze(t) {
  T.setTimeout = t.setTimeout, T.clearTimeout = t.clearTimeout, T.setInterval = t.setInterval, T.clearInterval = t.clearInterval;
}

var Y = {},
    Xe = /*#__PURE__*/function () {
  function Xe(e) {
    _classCallCheck(this, Xe);

    this.closed = !1;
    this.mc = new MessageChannel();
    this.name = e, Y[e] = Y[e] || [], Y[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
  }

  _createClass(Xe, [{
    key: "onStorage",
    value: function onStorage(e) {
      if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
      var n = JSON.parse(e.newValue);
      this.mc.port2.postMessage(n);
    }
  }, {
    key: "postMessage",
    value: function postMessage(e) {
      var _this = this;

      if (this.closed) throw new Error("InvalidStateError");
      var n = JSON.stringify(e),
          r = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
      window.localStorage.setItem(r, n), T.setTimeout(function () {
        window.localStorage.removeItem(r);
      }, 500), Y[this.name].forEach(function (a) {
        a !== _this && a.mc.port2.postMessage(JSON.parse(n));
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (this.closed) return;
      this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
      var e = Y[this.name].indexOf(this);
      Y[this.name].splice(e, 1);
    }
  }, {
    key: "onmessage",
    get: function get() {
      return this.mc.port1.onmessage;
    },
    set: function set(e) {
      this.mc.port1.onmessage = e;
    }
  }, {
    key: "onmessageerror",
    get: function get() {
      return this.mc.port1.onmessageerror;
    },
    set: function set(e) {
      this.mc.port1.onmessageerror = e;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(e, n) {
      return this.mc.port1.addEventListener(e, n);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(e, n) {
      return this.mc.port1.removeEventListener(e, n);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      return this.mc.port1.dispatchEvent(e);
    }
  }]);

  return Xe;
}(),
    $e = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : Xe;

function Ke() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (e) {
    return T.setTimeout(e, t);
  });
}

function ae() {
  return Math.random().toString(36).substring(2);
}

var l;

(function (o) {
  o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})(l || (l = {}));

var Ee = /*#__PURE__*/function () {
  function Ee(e, n) {
    _classCallCheck(this, Ee);

    this.token = ae();
    this.isLeader = !1;
    this.isDead = !1;
    this.isApplying = !1;
    this.reApply = !1;
    this.intervals = [];
    this.listeners = [];
    this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }

  _createClass(Ee, [{
    key: "apply",
    value: function () {
      var _apply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var e, n;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.isLeader || this.isDead)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", !1);

              case 2:
                if (!this.isApplying) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", (this.reApply = !0, !1));

              case 4:
                this.isApplying = !0;
                e = !1, n = function n(r) {
                  var _r$data = r.data,
                      a = _r$data.token,
                      u = _r$data.action;
                  a !== _this2.token && (u === l.APPLY && a > _this2.token && (e = !0), u === l.TELL && (e = !0));
                };
                this.channel.addEventListener("message", n);
                _context.prev = 7;
                this.sendAction(l.APPLY);
                _context.next = 11;
                return Ke(this.options.responseTime);

              case 11:
                this.channel.removeEventListener("message", n);
                this.isApplying = !1;
                return _context.abrupt("return", e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0));

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return", !1);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 16]]);
      }));

      function apply() {
        return _apply.apply(this, arguments);
      }

      return apply;
    }()
  }, {
    key: "awaitLeadership",
    value: function awaitLeadership() {
      var _this3 = this;

      if (this.isLeader) return Promise.resolve();
      var e = !1,
          n = null;
      return new Promise(function (r) {
        var a = function a() {
          if (e) return;
          e = !0, T.clearInterval(n);

          var b = _this3.intervals.indexOf(n);

          _this3.intervals.splice(b, 1), _this3.channel.removeEventListener("message", u), r();
        };

        n = T.setInterval(function () {
          _this3.apply().then(function () {
            _this3.isLeader && a();
          });
        }, _this3.options.fallbackInterval), _this3.intervals.push(n);

        var u = function u(b) {
          var W = b.data.action;
          W === l.CLOSE && _this3.apply().then(function () {
            _this3.isLeader && a();
          });
        };

        _this3.channel.addEventListener("message", u);
      });
    }
  }, {
    key: "sendAction",
    value: function sendAction(e) {
      this.channel.postMessage({
        action: e,
        token: this.token
      });
    }
  }, {
    key: "assumeLead",
    value: function assumeLead() {
      var _this4 = this;

      this.isLeader = !0;

      var e = function e(n) {
        var r = n.data.action;
        r === l.APPLY && _this4.sendAction(l.TELL);
      };

      return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(l.TELL);
    }
  }, {
    key: "waitForLeadership",
    value: function waitForLeadership() {
      return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
  }, {
    key: "close",
    value: function close() {
      var _this5 = this;

      this.isDead || (this.isDead = !0, this.isLeader = !1, this.sendAction(l.CLOSE), this.listeners.forEach(function (e) {
        return _this5.channel.removeEventListener("message", e);
      }), this.intervals.forEach(function (e) {
        return T.clearInterval(e);
      }));
    }
  }]);

  return Ee;
}();

var k;

(function (r) {
  r[r.PROMPTED = 0] = "PROMPTED", r[r.ACTIVE = 1] = "ACTIVE", r[r.IDLE = 2] = "IDLE";
})(k || (k = {}));

var be = /*#__PURE__*/function () {
  function be(e) {
    var _this6 = this;

    _classCallCheck(this, be);

    this.token = ae();
    this.registry = new Map();
    this.allIdle = !1;
    var n = e.channelName;

    if (this.options = e, this.channel = new $e(n), this.registry.set(this.token, 1), e.leaderElection) {
      var r = {
        fallbackInterval: 2e3,
        responseTime: 100
      };
      this.elector = new Ee(this.channel, r), this.elector.waitForLeadership();
    }

    this.channel.addEventListener("message", function (r) {
      var _r$data2 = r.data,
          a = _r$data2.action,
          u = _r$data2.token,
          b = _r$data2.data;

      switch (a) {
        case l.REGISTER:
          _this6.registry.set(u, 2);

          break;

        case l.DEREGISTER:
          _this6.registry.delete(u);

          break;

        case l.IDLE:
          _this6.idle(u);

          break;

        case l.ACTIVE:
          _this6.active(u);

          break;

        case l.PROMPT:
          _this6.prompt(u);

          break;

        case l.START:
          _this6.start(u);

          break;

        case l.RESET:
          _this6.reset(u);

          break;

        case l.ACTIVATE:
          _this6.activate(u);

          break;

        case l.PAUSE:
          _this6.pause(u);

          break;

        case l.RESUME:
          _this6.resume(u);

          break;

        case l.MESSAGE:
          _this6.options.onMessage(b);

          break;
      }
    }), this.send(l.REGISTER);
  }

  _createClass(be, [{
    key: "isLeader",
    get: function get() {
      if (!this.elector) throw new Error("\u274C Leader election is not enabled. To Enable it set the \"leaderElection\" property to true.");
      return this.elector.isLeader;
    }
  }, {
    key: "prompt",
    value: function prompt() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 0);

      var n = _toConsumableArray(this.registry.values()).every(function (r) {
        return r === 0;
      });

      e === this.token && this.send(l.PROMPT), n && this.options.onPrompt();
    }
  }, {
    key: "idle",
    value: function idle() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 2);

      var n = _toConsumableArray(this.registry.values()).every(function (r) {
        return r === 2;
      });

      e === this.token && this.send(l.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
    }
  }, {
    key: "active",
    value: function active() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1);

      var n = _toConsumableArray(this.registry.values()).some(function (r) {
        return r === 1;
      });

      e === this.token && this.send(l.ACTIVE), n && this.options.onActive();
    }
  }, {
    key: "start",
    value: function start() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.START) : this.options.start(!0);
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.RESET) : this.options.reset(!0);
    }
  }, {
    key: "activate",
    value: function activate() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.ACTIVATE) : this.options.activate(!0);
    }
  }, {
    key: "pause",
    value: function pause() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(l.PAUSE) : this.options.pause(!0);
    }
  }, {
    key: "resume",
    value: function resume() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(l.RESUME) : this.options.resume(!0);
    }
  }, {
    key: "message",
    value: function message(e) {
      try {
        this.channel.postMessage({
          action: l.MESSAGE,
          token: this.token,
          data: e
        });
      } catch (_unused2) {}
    }
  }, {
    key: "send",
    value: function send(e) {
      try {
        this.channel.postMessage({
          action: e,
          token: this.token
        });
      } catch (_unused3) {}
    }
  }, {
    key: "close",
    value: function close() {
      this.options.leaderElection && this.elector.close(), this.send(l.DEREGISTER), this.channel.close();
    }
  }]);

  return be;
}();

var Qe = w ? document : null,
    ge = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange"];
import { useRef as yt, useEffect as Lt } from "react";

function F(t) {
  var e = yt(t);
  return Lt(function () {
    e.current = t;
  }, [t]), e;
}

function Ze(t, e) {
  var n;

  function r() {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    n && clearTimeout(n), n = setTimeout(function () {
      t.apply(void 0, a), n = null;
    }, e);
  }

  return r.cancel = function () {
    clearTimeout(n);
  }, r;
}

function le(t, e) {
  var n = 0;
  return function () {
    var a = new Date().getTime();
    if (!(a - n < e)) return n = a, t.apply(void 0, arguments);
  };
}

var E = function E() {
  return w ? performance.now() : Date.now();
};

function $() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$timeout = _ref2.timeout,
      t = _ref2$timeout === void 0 ? 1e3 * 60 * 20 : _ref2$timeout,
      _ref2$promptTimeout = _ref2.promptTimeout,
      e = _ref2$promptTimeout === void 0 ? 0 : _ref2$promptTimeout,
      _ref2$element = _ref2.element,
      n = _ref2$element === void 0 ? Qe : _ref2$element,
      _ref2$events = _ref2.events,
      r = _ref2$events === void 0 ? ge : _ref2$events,
      _ref2$timers = _ref2.timers,
      a = _ref2$timers === void 0 ? void 0 : _ref2$timers,
      _ref2$immediateEvents = _ref2.immediateEvents,
      u = _ref2$immediateEvents === void 0 ? [] : _ref2$immediateEvents,
      _ref2$onPrompt = _ref2.onPrompt,
      b = _ref2$onPrompt === void 0 ? function () {} : _ref2$onPrompt,
      _ref2$onIdle = _ref2.onIdle,
      W = _ref2$onIdle === void 0 ? function () {} : _ref2$onIdle,
      _ref2$onActive = _ref2.onActive,
      ee = _ref2$onActive === void 0 ? function () {} : _ref2$onActive,
      _ref2$onAction = _ref2.onAction,
      m = _ref2$onAction === void 0 ? function () {} : _ref2$onAction,
      _ref2$onMessage = _ref2.onMessage,
      c = _ref2$onMessage === void 0 ? function () {} : _ref2$onMessage,
      _ref2$debounce = _ref2.debounce,
      d = _ref2$debounce === void 0 ? 0 : _ref2$debounce,
      _ref2$throttle = _ref2.throttle,
      p = _ref2$throttle === void 0 ? 0 : _ref2$throttle,
      _ref2$eventsThrottle = _ref2.eventsThrottle,
      h = _ref2$eventsThrottle === void 0 ? 200 : _ref2$eventsThrottle,
      _ref2$startOnMount = _ref2.startOnMount,
      o = _ref2$startOnMount === void 0 ? !0 : _ref2$startOnMount,
      _ref2$startManually = _ref2.startManually,
      x = _ref2$startManually === void 0 ? !1 : _ref2$startManually,
      _ref2$stopOnIdle = _ref2.stopOnIdle,
      M = _ref2$stopOnIdle === void 0 ? !1 : _ref2$stopOnIdle,
      _ref2$crossTab = _ref2.crossTab,
      G = _ref2$crossTab === void 0 ? !1 : _ref2$crossTab,
      _ref2$name = _ref2.name,
      we = _ref2$name === void 0 ? "idle-timer" : _ref2$name,
      _ref2$syncTimers = _ref2.syncTimers,
      J = _ref2$syncTimers === void 0 ? 0 : _ref2$syncTimers,
      _ref2$leaderElection = _ref2.leaderElection,
      ye = _ref2$leaderElection === void 0 ? !1 : _ref2$leaderElection;

  var q = f(E()),
      Le = f(Date.now()),
      te = f(E()),
      D = f(null),
      N = f(null),
      z = f(0),
      v = f(!0),
      A = f(!1),
      B = f(!0),
      X = f(!1),
      g = f(!1),
      y = f(0),
      R = f(0),
      O = f(null),
      s = f(null),
      C = F(t),
      re = F(e),
      et = F(M),
      ke = f(u),
      ce = f(n),
      me = f(_toConsumableArray(new Set([].concat(_toConsumableArray(r), _toConsumableArray(u))).values())),
      xe = F(W),
      de = F(ee),
      Me = F(b),
      ne = F(c),
      L = f();
  U(function () {
    L.current && L.current.cancel && L.current.cancel(), d > 0 ? L.current = Ze(m, d) : p > 0 ? L.current = le(m, p) : L.current = m;
  }, [m, p, d]);
  var Pe = f();
  U(function () {
    G && J && (Pe.current = le(function () {
      s.current.active();
    }, J));
  }, [G, J]);

  var P = function P() {
    O.current !== null && (T.clearTimeout(O.current), O.current = null);
  },
      V = function V(i) {
    var S = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    P(), O.current = T.setTimeout(fe, i || C.current), S && (N.current = E());
  },
      Se = function Se(i) {
    y.current = 0, R.current = E(), g.current = !0, V(re.current, !1), Me.current(i);
  },
      Ae = function Ae() {
    P(), v.current = !0, D.current = E(), et.current ? H() : g.current && (R.current = 0, g.current = !1), xe.current();
  },
      pe = function pe(i) {
    P(), g.current = !1, R.current = 0, v.current = !1, z.current += E() - D.current, _(), V(), de.current(i);
  },
      fe = function fe(i) {
    if (!v.current) {
      if (L.current.cancel && L.current.cancel(), re.current > 0 && !g.current) {
        s.current ? s.current.prompt() : Se(i);
        return;
      }

      s.current ? s.current.idle() : Ae();
      return;
    }

    s.current ? s.current.active() : pe(i);
  },
      Re = function Re(i) {
    if (L.current(i), g.current) return;

    if (P(), !v.current && ke.current.includes(i.type)) {
      fe(i);
      return;
    }

    var S = E() - N.current;

    if (v.current && !M || !v.current && S > C.current) {
      fe(i);
      return;
    }

    A.current = !1, y.current = 0, R.current = 0, V(), G && J && Pe.current();
  },
      oe = f();

  U(function () {
    var i = X.current;
    i && H(), h > 0 ? oe.current = le(Re, h) : oe.current = Re, i && _();
  }, [h, G, J]);

  var _ = function _() {
    !w || X.current || (me.current.forEach(function (i) {
      ce.current.addEventListener(i, oe.current, {
        capture: !0,
        passive: !0
      });
    }), X.current = !0);
  },
      H = function H() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    !w || (X.current || i) && (me.current.forEach(function (S) {
      ce.current.removeEventListener(S, oe.current, {
        capture: !0
      });
    }), X.current = !1);
  },
      j = I(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, s.current && !i && s.current.start(), V();
  }, [O, v, C, s]),
      he = I(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, q.current = E(), te.current = E(), s.current && !i && s.current.reset(), x || V();
  }, [O, v, C, x, s]),
      Oe = I(function (i) {
    P(), _(), (v.current || g.current) && pe(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, te.current = E(), s.current && !i && s.current.activate(), V();
  }, [O, v, C, s]),
      ve = I(function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return A.current ? !1 : (y.current = Ce(), A.current = !0, H(), P(), s.current && !i && s.current.pause(), !0);
  }, [O, s]),
      Te = I(function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return A.current ? (A.current = !1, g.current || _(), v.current || V(y.current), R.current && (R.current = E()), s.current && !i && s.current.resume(), !0) : !1;
  }, [O, C, y, s]),
      tt = I(function (i, S) {
    s.current ? (S && ne.current(i), s.current.message(i)) : S && ne.current(i);
  }, [c]),
      rt = I(function () {
    return v.current;
  }, [v]),
      nt = I(function () {
    return g.current;
  }, [g]),
      ot = I(function () {
    if (!s.current) throw new Error("\u274C Cross Tab feature is not enabled. To enable it set the \"crossTab\" property to true.");
    return s.current.isLeader;
  }, [s]),
      it = I(function () {
    if (!s.current) throw new Error("\u274C Cross Tab feature is not enabled. To enable it set the \"crossTab\" property to true.");
    return s.current.token;
  }, [s]),
      Ce = I(function () {
    if (A.current) return y.current;

    var i = y.current ? y.current : re.current + C.current,
        S = N.current ? E() - N.current : 0,
        _e = Math.ceil(i - S);

    return _e < 0 ? 0 : Math.abs(_e);
  }, [C, re, g, y, N]),
      st = I(function () {
    return Math.round(E() - te.current);
  }, [te]),
      De = I(function () {
    return Math.round(E() - q.current);
  }, [q]),
      at = I(function () {
    return D.current ? new Date(Le.current - q.current + D.current) : null;
  }, [D]),
      lt = I(function () {
    return N.current ? new Date(Le.current - q.current + N.current) : null;
  }, [N]),
      Ne = I(function () {
    return v.current ? Math.round(E() - D.current + z.current) : Math.round(z.current);
  }, [D, z]),
      ut = I(function () {
    var i = Math.round(De() - Ne());
    return i >= 0 ? i : 0;
  }, [q, D, z]);

  return U(function () {
    if (d > 0 && p > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
    a && ze(a);

    var i = function i() {
      s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };

    return w && window.addEventListener("beforeunload", i), function () {
      w && window.removeEventListener("beforeunload", i), s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };
  }, []), U(function () {
    s.current && s.current.close(), G ? s.current = new be({
      channelName: we,
      leaderElection: ye,
      onPrompt: function onPrompt() {
        Se();
      },
      onIdle: function onIdle() {
        Ae();
      },
      onActive: function onActive() {
        pe();
      },
      onMessage: ne.current,
      start: j,
      reset: he,
      activate: Oe,
      pause: ve,
      resume: Te
    }) : s.current = null;
  }, [G, we, ye, Me, xe, de, ne, j, he, ve, Te]), U(function () {
    P(), H(!0), B.current || (A.current = !0, v.current = !0, y.current = 0), !x && (o ? j() : _());
  }, [x, o, B]), U(function () {
    if (!B.current) {
      var i = _toConsumableArray(new Set([].concat(_toConsumableArray(r), _toConsumableArray(u))).values());

      if (H(), me.current = i, ce.current = n, ke.current = u, x) return;
      o ? j() : _();
    }
  }, [n, JSON.stringify(r), JSON.stringify(u), B, x, o]), U(function () {
    if (B.current) B.current = !1;else {
      if (C.current = t, x) return;
      v.current && (de.current(), s.current && s.current.active()), j();
    }
  }, [t, s, x, B, v]), {
    message: tt,
    start: j,
    reset: he,
    activate: Oe,
    pause: ve,
    resume: Te,
    isIdle: rt,
    isPrompted: nt,
    isLeader: ot,
    getTabId: it,
    getRemainingTime: Ce,
    getElapsedTime: st,
    getTotalElapsedTime: De,
    getLastIdleTime: at,
    getLastActiveTime: lt,
    getTotalIdleTime: Ne,
    getTotalActiveTime: ut
  };
}

import kt, { createContext as xt, useContext as Mt } from "react";
var ue = xt(null);

function Pt(t) {
  var e = $(t);
  return kt.createElement(ue.Provider, {
    value: e
  }, t.children);
}

var St = ue.Consumer;

function At() {
  return Mt(ue);
}

export { ge as DEFAULT_EVENTS, St as IdleTimerConsumer, ue as IdleTimerContext, Pt as IdleTimerProvider, wt as createMocks, $ as useIdleTimer, At as useIdleTimerContext, gt as withIdleTimer, Z as workerTimers };